import React, { useState } from 'react';
import { Grid, Button, TextField } from '@mui/material';
import { EventLocation } from '../../../../types';
import { eventsService } from '../../../../core/services/eventsService';
import styles from '../SchedulerSetting.module.scss';

interface EditEventLocationProps {
	location: EventLocation;
	handleBackClick?: () => void;
	onEventLocationUpdated?: () => void;
}

const EditEventLocation: React.FC<EditEventLocationProps> = ({
	location,
	handleBackClick,
	onEventLocationUpdated,
}) => {
	const [locationBuffer, setLocationBuffer] = useState({
		label: location.label || location.name || '',
	});
	const [isSubmitting, setIsSubmitting] = useState(false);
	const [error, setError] = useState<string | null>(null);

	const handleSubmit = async (e: React.FormEvent) => {
		e.preventDefault();
		setError(null);

		if (!locationBuffer.label.trim()) {
			setError('Event location is required');
			return;
		}

		try {
			setIsSubmitting(true);
			await eventsService.updateEventLocation({
				...location,
				label: locationBuffer.label,
				active: true, // Always pass true
			});

			onEventLocationUpdated?.();
			setTimeout(() => {
				handleBackClick?.();
			}, 500);
		} catch (err: any) {
			setError(err?.message || 'Failed to update event location');
			setIsSubmitting(false);
		}
	};

	return (
		<div className={styles.editTimeOffReason}>
			<Grid container direction="column" spacing={2} pl={2}>
				<Grid container direction="row" justifyContent="space-between">
					<Button className={styles.backButton} onClick={handleBackClick}>
						Back
					</Button>
					<Button
						className={styles.submitButton}
						onClick={handleSubmit}
						disabled={isSubmitting || !locationBuffer.label.trim()}
					>
						{isSubmitting ? 'Saving...' : 'Save'}
					</Button>
				</Grid>
				<Grid>
					<h1 className={styles.formTitle}>Edit Event Location</h1>
				</Grid>
			</Grid>

			<form className={styles.formContainer} onSubmit={handleSubmit}>
				<TextField
					label="Event Location"
					name="label"
					value={locationBuffer.label}
					onChange={(e) => {
						setLocationBuffer({ ...locationBuffer, label: e.target.value });
						if (error) {
							setError(null);
						}
					}}
					placeholder="Enter event location"
					className={styles.input}
					margin="normal"
					fullWidth
					inputProps={{ maxLength: 200 }}
					error={!!error}
					helperText={error || ''}
				/>
			</form>
		</div>
	);
};

export default EditEventLocation;

